import React from 'react';
import { Chart } from 'primereact/chart';
import { ProgressSpinner } from 'primereact/progressspinner'; // Import ProgressSpinner

interface DiseaseChartProps {
  title: string;
  chartData: any;
  loading: boolean; // Add loading prop
}

const DiseaseChart: React.FC<DiseaseChartProps> = ({ title, chartData, loading }) => {
  const options = {
    scales: {
      y: {
        beginAtZero: true,
      },
    },
  };

  return (
    <div className="chart-container">
      {/* <h5>{title}</h5> */}
      {loading ? (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '200px' }}>
          <ProgressSpinner />
        </div>
      ) : (
        chartData ? <Chart type="line" data={chartData} options={options} /> : <p>Selecione uma UF para ver os dados.</p>
      )}
    </div>
  );
};

export default DiseaseChart;